import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';

import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { Option } from '@shared/types/components.type';

@Component({
  imports: [NgSelectComponent, TooltipDirective, FormsModule],
  selector: 'aux-forecast-table-grid-period-patient',
  styleUrls: ['./forecast-table-grid-period-patient.component.scss'],
  templateUrl: './forecast-table-grid-period-patient.component.html',
})
export class ForecastTableGridPeriodPatientComponent {
  @ViewChild('gridPeriodPatient') public input!: NgSelectComponent;
  @Input() periodPatientOptions: Option<string>[] = [];
  @Input() selectedPeriodPatientOption = '';
  @Input() tooltip = '';
}
